import { useEffect, useState } from 'react';
import { useForm } from '@abyss/web/hooks/useForm';
import { BreadcrumbService } from '@src/api/common/BreadcrumbService';
import { PageTitleService } from '@src/api/common/PageTitleService';
import { Breadcrumbs, Title } from './PageInfo';
import { CookieService } from '@src/api/common/CookieService';

const SetUserController = () => {
  const { UpdateBreadcrumb } = BreadcrumbService();
  const { UpdatePageTitle } = PageTitleService();
  const [fieldsDisabled, setFieldsDisabled] = useState<boolean>(false);

  const form = useForm({
    defaultValues: {
      displayName: '',
      initials: '',
    },
  });

  const DataSource = {
    LoadUser: async () => {
      const cookie = CookieService.GetCookie('authUser');
      if (cookie) {
        const user = JSON.parse(cookie);
        await form.reset(user);
        await setFieldsDisabled(true);
      } else {
        await form.reset();
        await setFieldsDisabled(false);
      }
    },
  };

  const Action = {
    Init: async () => {
      await UpdateBreadcrumb(Breadcrumbs);
      await UpdatePageTitle(Title);
      await Action.Load();
    },
    Load: async () => {
      DataSource.LoadUser();
    },
    ApplyClick: async () => {
      if (!fieldsDisabled) {
        const { displayName, initials } = await form.getValues();
        if (displayName && initials && initials.length > 0 && initials.length <= 2 && displayName.length > 0) {
          const user = await form.getValues();
          await CookieService.SaveCookie('authUser', user);
          await setFieldsDisabled(!fieldsDisabled);
          await Action.ReloadPage();
        }
      } else {
        await CookieService.DeleteCookie('authUser');
        await form.reset();
        await setFieldsDisabled(!fieldsDisabled);
        await Action.ReloadPage();
      }
    },
    ReloadPage: async () => {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
  };

  useEffect(() => {
    Action.Init();
  }, []);

  return {
    form,
    Action,
    fieldsDisabled,
  };
};

export { SetUserController };
